module.exports = require("tsconfig-paths-webpack-plugin");